import {
  GET_SUBCATEGORIES, GET_SUBCATEGORIESPAG, CREATE_SUBCATEGORIES, UPDATE_SUBCATEGORIES, SET_MESSAGE, GET_ERRORS, DEACTIVATE_SUBCATEGORIES, ACTIVATE_SUBCATEGORIES
} from "../actions/types";

const initialState = {
  subcategoriespag: [],
  subcategories: [],
  error: "",
  actionType: ""
};


export default function (state = initialState, action) {
  switch (action.type) {
    case CREATE_SUBCATEGORIES:
      return {
        ...state,
        actionType: action.type,
      };
    case UPDATE_SUBCATEGORIES:
      return {
        ...state,
        actionType: action.type,
      };
    case GET_SUBCATEGORIES:
      return {
        ...state,
        subcategories: action.payload.message,
        actionType: action.type,
      };
    case GET_SUBCATEGORIESPAG:
      return {
        ...state,
        subcategoriespag: action.payload.message,
        actionType: action.type,
      };
    case DEACTIVATE_SUBCATEGORIES:
      return {
        ...state,
        closeModal: true,
        actionType: action.type,
      };
    case ACTIVATE_SUBCATEGORIES:
      return {
        ...state,
        closeModal: true,
        actionType: action.type,
      };
    case GET_ERRORS:
      return {
        ...state,
        error: action.payload

      };

    case SET_MESSAGE:
      return {
        ...state,
        success: action.payload.message
      };

    default:
      return state;
  }
}